import * as R from 'ramda';
import React from 'react';
import ContractThumb from '../../components/contract/ContractThumb';
import Moment from 'moment';
import { Collapse, Tag } from 'antd';
const Panel = Collapse.Panel;
import { getContractStatus } from '../../lib/Status';
import LocalPagination from '../../components/LocalPagination';
import getAmendmentInfos from '../../lib/getAmendmentInfos';

const PanelHeader = ({ node }) => {
  const { courseIsAmendment } = getAmendmentInfos(node);
  const { id, propositionNumber, status, siret, dates = {} } = node;

  return <div style={{ display: 'flex' }}>
    <div style={{ flex: 2 }}>
      <Tag
        title={id}
        onClick={() => navigator.clipboard.writeText(id)}
      >
        Proposition : <b>{propositionNumber}</b>
      </Tag>

      <Tag
        onClick={() => navigator.clipboard.writeText(siret)}
      >
        {`SIRET : ${siret}`}
      </Tag>

      <Tag>
        {!R.isNil(dates) && Moment(dates.lastUpdate).format('DD/MM/YYYY HH:mm:ss')}
      </Tag>

      {courseIsAmendment && <Tag>
        {'AVENANT'}
      </Tag>}
    </div>

    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
      <Tag color={R.prop(status, {
        'unhold': 'cyan',
        'active': 'gold',
        'closed': 'purple',
        'confirmed': 'blue',
        'sendingForSignature': 'volcano',
        'sentForSignature': 'volcano',
        'sentForSignatureDelayed': 'volcano',
        'sentToManagementSystem': 'lime',
        'rejectedByManagementSystem': 'cyan',
        'confirmedInManagementSystem': 'magenta',
        'confirmedInManagementSystemReopened': 'magenta',
        'duplicate': 'blue'
      })}
      >
        {getContractStatus(status)}
      </Tag>
    </div>
  </div>;
};

const Space = () => <div style={{ margin: '8px 0' }}/>;

const ContractList = ({
  contracts,
  pagination,
  onUpdatePageNumber,
  onUpdatePageSize
}) => {

  if (R.isEmpty(contracts)) return (
    <div>
      Pas de réponse
    </div>
  );

  return (
    <React.Fragment>
      <LocalPagination pagination={pagination} onUpdatePageNumber={onUpdatePageNumber} onUpdatePageSize={onUpdatePageSize} type="top"/>
      <Space/>
      <Collapse
        accordion
      >
        {contracts.map((contract) => (
          <Panel header={<PanelHeader node={contract}/>} key={contract.id}>
            <ContractThumb key={contract.id} contract={contract}/>
          </Panel>
        ))}
      </Collapse>
      <Space/>
      <LocalPagination pagination={pagination} onUpdatePageNumber={onUpdatePageNumber} onUpdatePageSize={onUpdatePageSize} type="bot"/>
    </React.Fragment>
  );
};

ContractList.defaultProps = {
  count: 25
};

export default ContractList;
